import { render, staticRenderFns } from "./PromoBoxBremen.vue?vue&type=template&id=2a08c057&scoped=true"
import script from "./PromoBoxBremen.vue?vue&type=script&lang=js"
export * from "./PromoBoxBremen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a08c057",
  null
  
)

export default component.exports